import { select, takeLatest } from '@redux-saga/core/effects';
import { ACTION_TOGGLE } from '../actions/layout';
import { LS_LAYOUT_KEY } from '../reducers/layout';
import { SET_TIMEZONE } from '../actions/timezone';
import { LS_TIMEZONE_KEY } from '../reducers/timezone';
import { IStore } from '../reducers';

/**
 * Save layout changes to localStorage
 */
function* onSaveLayout(): any {
  const layout: any = yield select((state: IStore) => state.layout);
  if (window.localStorage) {
    localStorage.setItem(LS_LAYOUT_KEY, JSON.stringify(layout));
  }
}

/**
 * Save timezone to localStorage
 */
function* onSaveTimezone(): any {
  const timezone: any = yield select((state: IStore) => state.timezone.current);
  if (window.localStorage) {
    localStorage.setItem(LS_TIMEZONE_KEY, timezone);
  }
}

export default function* accountsSaga() {
  yield takeLatest(ACTION_TOGGLE, onSaveLayout);
  yield takeLatest(SET_TIMEZONE, onSaveTimezone);
}
